module.exports = __webpack_public_path__ + "static/media/geometric.d.ts.bb6a81fc.map";